import CardsWithIntro from 'components/slices/CardsWithIntro'
import React, { useRef, useState, useEffect } from 'react'
import { fetchIntegrationsCardCategory } from 'services/clientApi'

const IntegrationsCardsWithIntro = ({ cards, buttonText, res, ...rest }) => {
  /**
   * Some cards are not renamed correctly
   */
  const changeCardsText = (oldCards) =>
    oldCards.map((card) => ({
      ...card,
      link: { ...card.link, text: buttonText },
    }))
  const defaultCards = cards ? changeCardsText(cards) : []
  const [integrationsCards, setIntegrationsCards] = useState(defaultCards)
  const [page, setPage] = useState(1)
  const categoryId = useRef(res?.categoryId)
  const count = useRef(res?.count)
  const limit = 6

  /**
   * Check for duplicates
   */
  const filterCards = (allCards) =>
    allCards.filter(
      (card, index, self) => index === self.findIndex((c) => c.id === card.id)
    )

  /**
   * Get the cards for the next page
   * filter the duplicates
   * and after filtering check if there is enough to fill the row
   * if no, fill up the row with recursion
   */
  const fetchCards = async (currentCards, maxCards, usedPage = 1) => {
    let result = currentCards
    const newCards = await fetchIntegrationsCardCategory({
      buttonText: '',
      page: usedPage,
      limit,
    })

    result = filterCards([...result, ...newCards.integrations])

    const max = maxCards

    if (result.length < count.current && result.length < max) {
      result = await fetchCards(result, max, usedPage + 1)
    }

    if (result.length > max) {
      result = result.slice(0, max)
    }

    return changeCardsText(result)
  }

  const onChange = async (value) => {
    const newCards = (categoryId.current = value)
    count.current = newCards?.count
    setPage(1)
    const editedNewCards = newCards ? changeCardsText(newCards) : []
    setIntegrationsCards(editedNewCards)
  }

  const loadMore = async () => {
    const pageVal = page + 1
    const newCards = await fetchCards(integrationsCards, pageVal * limit)
    setIntegrationsCards(newCards)
    setPage(pageVal)
  }

  const initCards = async () => {
    const newCards = await fetchCards(integrationsCards, 1 * limit)
    setIntegrationsCards(newCards)
  }

  useEffect(() => {
    initCards()
  }, [])

  return (
    <CardsWithIntro
      bottomLink
      buttonText={buttonText}
      category={categoryId.current}
      onChange={onChange}
      cards={integrationsCards}
      hasMore={page * limit < count.current}
      onClick={loadMore}
      {...rest}
    />
  )
}

export default IntegrationsCardsWithIntro
